exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".br-modal .br-modal__dialog {\n  overflow-y: scroll;\n}\n", ""]);

// exports
